import React, { useState, useEffect } from "react";

function Footer() {
  const currentYear = new Date().getFullYear();
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
        <footer className="footer-single-color text-white py-3">
          <div className="container text-center">
            <p className="mb-0">
              &copy; {currentYear} | <strong>anekant prakashan</strong> | All
              rights reserved.
            </p>
          </div>
        </footer>

      {showButton && (
        <button className="scroll-to-top-btn" onClick={scrollToTop}>
          ↑
        </button>
      )}
    </>
  );
}

export default Footer;
